import { Button, Result } from 'antd';
import { createBrowserRouter } from 'react-router';
import ErrorBoundary from '../components/error/ErrorBoundary';
import Layout from '../components/layout/Layout';
import { patientJourneyRoutes, patientRegisteryRoutes } from './routes';
import { AppMode } from '@ui/constants';

export const createAppRouter = (mode: AppMode) => {
    const appRoutes = {
        [AppMode.PATIENT_JOURNEY]: patientJourneyRoutes,
        [AppMode.PATIENT_REGISTRY]: patientRegisteryRoutes,
    };

    return createBrowserRouter([
        {
            path: '/',
            element: (
                <ErrorBoundary>
                    <Layout />
                </ErrorBoundary>
            ),
            errorElement: (
                <Result
                    status="404"
                    title="404"
                    subTitle="Sorry, the page you visited does not exist."
                    extra={
                        <Button
                            type="primary"
                            href="/"
                        >
                            Back Home
                        </Button>
                    }
                />
            ),
            children: appRoutes[mode],
        },
    ]);
};
